"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var WickedApiClient_1 = require("../../api/WickedApiClient");
var subscribtion_service_1 = require("../../Services/subscribtion.service");
var CancelSubscriptionComponent = /** @class */ (function () {
    function CancelSubscriptionComponent(dialogRef, data, subscribtionService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.subscribtionService = subscribtionService;
    }
    CancelSubscriptionComponent.prototype.ngOnInit = function () { };
    CancelSubscriptionComponent.prototype.onNoClick = function () {
        this.dialogRef.close(false);
    };
    CancelSubscriptionComponent.prototype.onYesClick = function () {
        var _this = this;
        this.subscribtionService.cancel(this.data.subscribtionId).then(function (response) {
            _this.dialogRef.close(true);
        });
    };
    return CancelSubscriptionComponent;
}());
exports.CancelSubscriptionComponent = CancelSubscriptionComponent;
